import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { genId } from "../core/services/genId";
import { Observable } from "rxjs";

import {
    TextTemplate
} from "../common/models/flow.dto";
import { lettercontentmodel } from "../models/comodel/lettercontentmodel.model";



@Injectable()
export class TextTemplatesService {

    constructor(public readonly http: HttpClient) { }


    save(id: string, letter: TextTemplate): Observable<TextTemplate> {
        console.log(`Saving ${id}`)
        return this.http.post<TextTemplate>(`/api/text-templates/${encodeURIComponent(id)}`, letter);
    }
    get(id: string): Observable<TextTemplate> {

        return this.http.get<TextTemplate>(`/api/text-templates/${encodeURIComponent(id)}`);
    }
    list(): Observable<TextTemplate[]> {
        return this.http.get<TextTemplate[]>(`/api/text-templates`);
    }
    delete(id: string): Observable<any> {
        return this.http.delete(`/api/text-templates/${id}`);
    }

    saveTemplateContent(letter: lettercontentmodel): Observable<lettercontentmodel> {        
        return this.http.post<lettercontentmodel>(`/api/text-templates/savelettercontent`, letter);
    }
    getTemplateContent(id: string): Observable<lettercontentmodel> {

        return this.http.get<lettercontentmodel>(`/api/text-templates/getletterContent/${id}`);
    }

}


export function updateRules(template: TextTemplate, beginTag?: string, endTag?: string): void {
    beginTag = beginTag || '[';
    endTag = endTag || ']';
    function escapeToken(text) { return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&'); }
    let re = new RegExp(escapeToken(beginTag) + ".*?" + escapeToken(endTag), 'g');
    let matches = template.content.match(re);
    let newRules = [];
    if (matches != null) {
        for (let p of matches) {
            let ruleName = p.trim();
            let ruleExpression = p.substring(beginTag.length, p.length - beginTag.length)
            newRules.push({
                ruleId: "",
                name: ruleName,
                expression: ruleExpression,
                parseTree: null
            });
        }
    }  

    let preserve = template.transforms.filter(r => newRules.findIndex(nr => nr.name === r.name) >= 0);
    let additional = newRules.filter(nr => template.transforms.findIndex(r => r.name === nr.name) === -1);
    let result = preserve.concat(additional);
    template.transforms = result;
}
